import { redirectAfterAuth } from "./auth-helpers";

export const followDecorated = (
  decorateUrl: (url: string) => string,
  destination: string = redirectAfterAuth()
): void => {
  const next = decorateUrl(destination);
  if (next.startsWith("http")) {
    window.location.href = next;
    return;
  }
  window.location.assign(next);
};
